import React from 'react';
import { SwapHorizRounded, SwapVertRounded } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { theme } from '../../../theme';
import ItemReplacementItemSummary from './ItemReplacementItemSummary';
import ItemReplacementVisual from './ItemReplacementVisual';

function ItemReplacementComparison({ currentItem, proposedItem, itemStats, status }) {
    // Hard-coded in contract true and false for the first release until contract context is provided by the API.
    const itemDisplayOrder = [
        { id: 'current', item: currentItem, label: 'Current Item', color: theme.palette.red.main, inContract: false, stats: itemStats.current, visualLabel: 'Current Item', direction: 'left' },
        { id: 'proposed', item: proposedItem, label: 'Replacement Item', color: theme.palette.green.main, inContract: true, stats: itemStats.recommended, visualLabel: 'Replacement Item', direction: 'right' }
    ];
    const isReplacementAccepted = status === 'accepted' || status === 'partially_reviewed';
    const itemsInDisplayOrder = isReplacementAccepted ? [...itemDisplayOrder].reverse() : itemDisplayOrder;

    return (
        <>
            <Stack spacing={1.25} sx={{ backgroundColor: theme.palette.background.white, borderRadius: 1, boxShadow: 1, p: 1.75 }}>
                <Stack direction='row' alignItems='center' spacing={{ xs: 1, sm: 2 }}>
                    {itemsInDisplayOrder.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <motion.div layout transition={{ type: 'spring', stiffness: 300, damping: 30 }} style={{ flex: 1, minWidth: 0 }}>
                                <ItemReplacementVisual item={item.item} label={item.visualLabel} color={item.color} direction={item.direction} />
                            </motion.div>
                            {index === 0 && <SwapHorizRounded sx={{ color: theme.palette.subtext.secondary }} />}
                        </React.Fragment>
                    ))}
                </Stack>
            </Stack>
            <Stack spacing={2.25}>
                {itemsInDisplayOrder.map((item, index) => (
                    <React.Fragment key={item.id}>
                        <motion.div layout transition={{ type: 'spring', stiffness: 300, damping: 30 }}>
                            <ItemReplacementItemSummary item={item.item} label={item.label} color={item.color} inContract={item.inContract} stats={item.stats} />
                        </motion.div>
                        {index === 0 && <SwapVertRounded sx={{ alignSelf: 'center', color: theme.palette.subtext.secondary }} />}
                    </React.Fragment>
                ))}
            </Stack>
        </>
    );
}

export default ItemReplacementComparison;
